import React from "react";
import id from "@irati/utils/id";
import { FormattedCurrency } from "@irati/utils/lang";
import { H2, H3, Label } from "@irati/ui/src/Typography";
import DealSavingsTypes from "@irati/deals/types/enums/DealSavingsType";
var Amount = function (props) {
    var idNamespace = props.idNamespace, savingsType = props.savingsType, savingsHeader = props.savingsHeader, savingsValue = props.savingsValue, currency = props.currency, small = props.small;
    var Heading = small ? H3 : H2;
    return (React.createElement("div", { id: id("savings-blocks", idNamespace) },
        React.createElement(Label, { id: id("savings-header", idNamespace), color: "contrast", display: "block", margin: 0, textAlign: "right" }, savingsHeader),
        React.createElement(Heading, { id: id("saving-amount", idNamespace), "data-test": "value" }, savingsType === DealSavingsTypes.PERCENTAGE ? (savingsValue + "%") : (React.createElement(FormattedCurrency, { isCents: false, value: savingsValue, currency: currency })))));
};
export default Amount;
